/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-05-12 17:50:42
 * @LastEditors: linxi
 * @LastEditTime: 2024-03-06 20:56:34
 */
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { ReactElement } from 'react'
import { getWaterTypeName } from './drinkWater'

export const DrinkingWaterColumns = (
  onclick: (id: number) => void,
  startIndex: number,
): TableColumnType<any>[] => {
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
      width: '3rem',
    },
    {
      title: '饮用水类别',
      dataIndex: 'category',
      align: 'center',
      key: 'category',
      render: (_, t) => {
        return t.category?.split(',')?.map((item: string) => getWaterTypeName(Number(item)))?.join(',')
      },
    },

    {
      title: '申报时间',
      dataIndex: 'applicantTime',
      align: 'center',
      key: 'applicantTime',
      render: (_, t) => {
        return moment(t.applicantTime).format('YYYY-MM-DD HH:mm')
      },
    },
    {
      title: '申报人',
      dataIndex: 'applicantUserName',
      align: 'center',
      key: 'applicantUserName',
      render: (_, t) => {
        return t.applicantUserName
      },
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      render: function ShowAction(_, t: any): ReactElement {
        return (
          <Button
            size='small'
            type='link'
            onClick={() => onclick(t.id)}
          >
            查看详情
          </Button>
        )
      },
    },
]

  return columns
}
